module.exports = __webpack_public_path__ + "img/294.f02f8b82.gif";